const getHugeRTE = (view) => {
    const global = view;
    return global && global.hugerte ? global.hugerte : null;
};
export { getHugeRTE };
